import styled, { css } from 'styled-components';
import { h4, small, stripButton } from 'styles/Typography';
import { toRem } from 'utils/helpers';
import {
  NO_FREE_APPOINTMENTS,
  ONLINE_AND_STAFF_AVAILABLE,
  ONLINE_AVAILABLE,
  STAFF_ONLY_AVAILABLE,
  StaffOnlyStatus,
} from '../../../../containers/staff/calendar/./common/useAppointmentOnlineStaffOnlySplit';

export const CalendarTopControlsWrapper = styled.div`
  margin-top: var(--s3);
  display: flex;
  justify-content: center;
  position: relative;

  .calendar-datepicker {
    min-width: ${toRem(130)}rem;
    max-width: ${toRem(130)}rem;
    margin: 0 var(--s2);
  }
`;

export const CalendarLeftControlsWrapper = styled.div`
  display: flex;
  flex-grow: 1;
  flex-basis: 0;
  justify-content: left;
  gap: var(--s2);
`;

export const CalendarMiddleControlsWrapper = styled.div``;

export const CalendarPrevNextRangePickerWrapper = styled.div`
  display: flex;
`;

export const CalendarWeekViewButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: var(--s2);
  margin-bottom: var(--s3);
`;

export const CalendarRightControlsWrapper = styled.div`
  display: flex;
  flex-grow: 1;
  flex-basis: 0;
  justify-content: right;
  gap: var(--s2);
`;

export const CalendarHeaderWrapper = styled.div`
  display: flex;
  border-bottom: ${toRem(2)}rem solid var(--greenprimary);
  position: relative;
  column-gap: var(--s3);
`;

export const CalendarRefreshButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: var(--s4);
`;
export const CalendarDateRangeViewWrapper = styled.div`
  margin-top: var(--s3);
  display: flex;
  flex-wrap: wrap;
  gap: var(--s3) var(--s3);
  justify-content: space-evenly;
`;
export const DayWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${toRem(2)}rem var(--s3);
`;
export const HourRow = styled.div`
  display: flex;
  gap: ${toRem(2)}rem;
  justify-content: space-between;
`;
export const TimeSlotPlaceHolder = styled.div`
  ${small};
  font-weight: 500;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: ${toRem(24)}rem;
  min-height: ${toRem(24)}rem;
  max-height: ${toRem(24)}rem;
`;
export const AppointmentSlotStyle = styled.button<{
  readonly slotType: StaffOnlyStatus | 'SELECTED' | 'DISABLED' | 'INVISIBLE';
}>`
  ${stripButton};
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: ${toRem(24)}rem;
  min-height: ${toRem(24)}rem;
  max-height: ${toRem(24)}rem;
  border-radius: ${toRem(4)}rem;
  font-weight: 500;
  ${({ slotType }) => {
    if (slotType === 'SELECTED')
      return css`
        color: var(--white);
        background-color: var(--yellowaction);
      `;
    if (slotType === 'DISABLED')
      return css`
        cursor: not-allowed;
        color: var(--white);
        background-color: var(--disabled);
      `;
    if (slotType === ONLINE_AVAILABLE)
      return css`
        color: var(--black);
        background-color: var(--greensecondary);
      `;

    if (slotType === ONLINE_AND_STAFF_AVAILABLE)
      return css`
        color: var(--black);
        background-color: var(--greensecondary);
        box-shadow: inset 0 0 0 2px var(--greenaccent);
      `;
    if (slotType === STAFF_ONLY_AVAILABLE)
      return css`
        color: var(--white);
        background-color: var(--greenaccent);
      `;
    if (slotType === NO_FREE_APPOINTMENTS)
      return css`
        color: var(--white);
        cursor: not-allowed;
        background-color: var(--rednegative);
      `;
    if (slotType === 'INVISIBLE') {
      return css`
        cursor: auto;
      `;
    }
  }}
`;
export const DayOuterWrapper = styled.div`
  min-width: 14.5rem; // Width of the longest title (Wednesday - XX.XX.XXXX)
  text-align: center;
`;
export const DayTitle = styled.h4`
  ${h4};
  text-align: center;
  margin-bottom: var(--s2);
  cursor: pointer;
`;
